import type { Dispatch, AnyAction } from 'redux';

import type { DeliverableDataListViewModel } from 'ab-viewModels/deliverableData.viewModel';

import type { DeliverableDataRequestModel } from 'ab-requestModels/deliverableData.requestModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

import API from 'af-constants/routes/api';

export function create(form: DeliverableDataRequestModel) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.post(API.V1.RESOURCES.DELIVERABLE.DATA.CREATE, form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function update(form: DeliverableDataRequestModel) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			if (!form.id) {
				throw new Error('Deliverable ID not provided');
			}
			await http.put(API.V1.RESOURCES.DELIVERABLE.DATA.EDIT(form.id.toString()), form);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function deleteData(id: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			await http.delete(API.V1.RESOURCES.DELIVERABLE.DATA.DELETE(id.toString()));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}

export function findAllForCompany() {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<DeliverableDataListViewModel>(API.V1.RESOURCES.DELIVERABLE.DATA.LIST);
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}
